const Notfoundpage = () => {
    return (
        <div className="notfoundpage" style={{
            width:"100%",
            height:"100vh",
            display:"flex",
            alignItems:"center",
            justifyContent:"center"
            }}>
            <h2>404 page Not Found</h2><br/>
            <h3>The page request url was not found. This page may have been removed or changed.</h3>
        </div>
      );
}
export default Notfoundpage;